export default __webpack_public_path__ + "static/media/pvn-arte-3.bf28f35c.webp";